import React from 'react'
import { Radio, Row, Col } from 'antd'
import ReportsPage from './Reports'
import { injectIntl } from 'react-intl'
import { requireAuthentication } from '../helpers/authentication'

const ReportMonitorContainer = ({ intl }) => {
  const [isMonitor, setIsMonitor] = React.useState(false)

  return (
    <div id="report-monitor-container">
      <Row>
        <Col span={10} />
        <Col span={2}>
          <Radio.Group
            options={[
              { label: 'Report', value: false },
              { label: 'Monitoring', value: true },
            ]}
            onChange={(e) => setIsMonitor(e.target.value)}
            value={isMonitor}
            optionType="button"
            block
            buttonStyle="solid"
            style={{ marginBottom: '16px' }}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24} id="reports-page-container">
          <ReportsPage intl={intl} isMonitor={isMonitor} />
        </Col>
      </Row>
    </div>
  )
}

export default requireAuthentication(injectIntl(ReportMonitorContainer))
